import {useContext, useState, useEffect} from 'react';
import classnames from 'classnames';
import { usePagination, DOTS } from './usePagination';
import rightArrow from '../images/Group 53/png/Group 53.png';
import leftArrow from '../images/Group 53 Copy/png/Group 53 Copy.png';
import './pagination.css';
import { NavLink, useLocation } from 'react-router-dom';
import LZString from 'lz-string';
import { TableDataContext } from '../Contexts/TableDataContext';

/**
 * The `Pagination` function is a component that renders a pagination UI with previous and next
 * buttons, page numbers, and dots for indicating skipped pages.
 * @returns The Pagination component is returning a JSX element that represents a pagination container.
 * It includes a list of pagination items, including previous and next buttons, and a range of page
 * numbers. The selected page is highlighted with a different style.
 */
const Pagination = props => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    monthPickerValue,
    className,
    allDataRoute = "",
    refineSearchFilters = {} // Added prop for refineSearchFilters
  } = props;
// console.log(allDataRoute,"allDataRoute")
  const [inputPage, setInputPage] = useState('');
  console.log(refineSearchFilters,"iutiwteo")
  const totalPages = Math.ceil(totalCount / pageSize);
  const{globalSearchResult} = useContext(TableDataContext);
  const location = useLocation();
  console.log(globalSearchResult,"globalSearchResultpagination",refineSearchFilters[location.pathname]?.globalSearch?.length)

  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter' && inputPage.trim()) {
      const page = Math.min(Math.max(1, parseInt(inputPage)), totalPages);
      onPageChange(page);
      setInputPage(''); // Clear input after navigation
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (!isNaN(value)) {
      // Only update if the value is not a number or is within the valid page range
      if (value === '' || parseInt(value) <= totalPages) {
        setInputPage(value);
      }
    }
  };

  const handleGoClick = () => {
    if (inputPage.trim()) {
      const page = Math.min(Math.max(1, parseInt(inputPage)), totalPages);
      onPageChange(page);
      setInputPage(''); // Clear input after navigation
    }
  };

  const onNext = () => {
    onPageChange(parseInt(currentPage) + 1);
  };

  const onArrowClick = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      onPageChange(newPage);
    }
  };

  const renderPageItem = (page) => (
    <li
      key={page}
      className={classnames('pagination-item', {
        selected: page === currentPage
      }) + " m-1 py-1 px-2 cursor-pointer" + (currentPage === page ? " bg-white" : "")}
      onClick={() => onPageChange(page)}
    >
      {page}
    </li>
  );

  // Build pages to show with your exact logic
  const pages = [];

  if (totalPages <= 5) {
    // If total pages is 5 or less, show all pages
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    if (currentPage <= 3) {
      // For pages 1, 2, 3: show 1 2 3 ... last
      pages.push(1);
      pages.push(2);
      pages.push(3);
      pages.push('dots');
      pages.push(totalPages);
    } else if (currentPage >= totalPages - 2) {
      // Show dots after first page, then the last few pages
      pages.push(1);
      pages.push('dots');
      for (let i = Math.max(2, totalPages - 2); i <= totalPages; i++) {
        if (!pages.includes(i)) {
          pages.push(i);
        }
      }
    } else {
      // Middle case: 1 ... (current-1) current (current+1) ... last
      pages.push(1);
      pages.push('dots-left');
      pages.push(currentPage - 1);
      pages.push(currentPage);
      pages.push(currentPage + 1);
      pages.push('dots-right');
      pages.push(totalPages);
    }
  }

const handleAllButtonClick = () => {
  // Check if we have global search results
  if (refineSearchFilters[location.pathname]?.globalSearch?.length === 1) {
    
    
    // Compress globalSearchResult and add to URL
    let gsParam = '';
    if (globalSearchResult && Object.keys(globalSearchResult).length > 0) {
      try {
        const serializedData = JSON.stringify(globalSearchResult);
        gsParam = LZString.compressToEncodedURIComponent(serializedData);
        console.log('Compressed globalSearchResult for URL:', gsParam);
      } catch (error) {
        console.error('Error compressing globalSearchResult for URL:', error);
      }
    }
    
    // Safely format the dates
    const formattedDateRange = Array.isArray(monthPickerValue) && monthPickerValue.length === 2
      ? `${formatDate(monthPickerValue[0])},${formatDate(monthPickerValue[1])}`
      : '';
    
    // Create URL with globalSearchResult parameter
    const baseUrl = allDataRoute.split('?')[0]; // Remove any existing query parameters
    const newUrl = `${baseUrl}?gs=${gsParam}&date=${formattedDateRange}`;
    
    window.open(newUrl, '_blank'); // Open in new tab with clean URL
  } else {
    // Original behavior when not using global search
    const compressed = LZString.compressToEncodedURIComponent(JSON.stringify(refineSearchFilters));

    // Safely format the dates
    const formattedDateRange = Array.isArray(monthPickerValue) && monthPickerValue.length === 2
      ? `${formatDate(monthPickerValue[0])},${formatDate(monthPickerValue[1])}`
      : '';

    const newUrl = `${allDataRoute}?filters=${compressed}&date=${formattedDateRange}`;
    window.open(newUrl, '_blank'); // Open in new tab
  }
};

// Helper function to convert Date or string into YYYY-MM-DD
const formatDate = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

  return (
    <center>
      <div className="flex items-center justify-center gap-2">
        {/* Main Pagination Container */}
        <ul className={classnames('pagination-container', { [className]: className })}>
          {/* Left Arrow */}
          <li
            className={currentPage === 1 ? "cursor-not-allowed pagination-item" : "cursor-pointer pagination-item"}
            onClick={currentPage !== 1 ? () => onArrowClick(currentPage - 1) : undefined}
          >
            <img src={leftArrow} className={currentPage === 1 ? "arrow-diable" : "arrow-default"} />
          </li>

          {/* Render Pages + Dots */}
          {pages.map((item, idx) => {
            if (item === 'dots' || item === 'dots-left' || item === 'dots-right') {
              return (
                <li key={`dots-${idx}`} className="pagination-item dots">
                  ...
                </li>
              );
            } else {
              return renderPageItem(item);
            }
          })}

          {/* All button - show only when totalPages < 11 */}
          {totalPages > 1 && totalPages < 11 && allDataRoute !== "" && (
            <li
              className="pagination-item m-1 py-1 px-2 cursor-pointer"
              onClick={handleAllButtonClick}
            >
              <NavLink>
                All
              </NavLink>
            </li>
          )}

          {/* Right Arrow */}
          <li
            className={currentPage === totalPages ? "cursor-not-allowed pagination-item" : "cursor-pointer pagination-item"}
            onClick={currentPage !== totalPages ? () => onArrowClick(currentPage + 1) : undefined}
          >
            <img src={rightArrow} className={currentPage === totalPages ? "arrow-diable" : "right-arrow-default"} />
          </li>
        </ul>

        {/* GO TO input box - positioned outside pagination container */}
        {totalPages > 10 && (
          <div className="flex items-center gap-1 ml-2">
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength="3"
              className="w-8 h-8 text-center border border-gray-300 text-sm focus:outline-none focus:border-blue-500"
              style={{ borderRadius: '2px' }}
              value={inputPage}
              onChange={handleInputChange}
              onKeyDown={handleInputKeyDown}
            />
            <button
              onClick={handleGoClick}
              className="px-1 py-1 text-xs text-white rounded hover:opacity-80 focus:outline-none"
              style={{ backgroundColor: '#bc8b20' }}
            >
              GO
            </button>
          </div>
        )}
      </div>
    </center>
  );
};

export default Pagination;